import { MsalAuthProvider, LoginType } from 'react-aad-msal';

export const clientId = process.env.REACT_APP_CLIENT_ID;

// Msal Configurations
const config = {
  auth: {
    authority: process.env.REACT_APP_AUTHORITY,
    clientId,
    redirectUri: window.location.origin,
    validateAuthority: false,
    navigateToLoginRequestUrl: false,
    // postLogoutRedirectUri: `${window.location.origin}/auth.html`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

// Authentication Parameters
const authenticationParameters = {
  scopes: [
    'openid', 'user.read'
  ]
};

// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: `${window.location.origin}/auth.html`
};

const authProvider = new MsalAuthProvider(config, authenticationParameters, options);

export default authProvider;
